import { c as _c } from "react/compiler-runtime";
import { STATES } from '@onefootprint/core';
import { Card, type TableRow } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useMobileLayout from '@/hooks/use-mobile-layout';
import type { FormattedRegistration } from '../../../../onboarding-business-insight.types';
import FlushTable from '../flush-table';
import DrawerFilter from './components/drawer-filter';
import MobileRow from './components/mobile-row';
import Row from './components/row';
import useSOSFilingStatesQueryParams from './hooks/use-sos-filings-states-query-params';
type SOSFilingsProps = {
  data: FormattedRegistration[];
  onClick: (registrationId: string) => void;
};
const SOSFilings = t0 => {
  const $ = _c(37);
  const {
    data,
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.registrations"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const queryParams = useSOSFilingStatesQueryParams();
  const isMobile = useMobileLayout();
  const {
    values
  } = queryParams;
  let t2;
  if ($[1] !== data || $[2] !== values.filingsStates) {
    t2 = values.filingsStates.length ? data.filter(t3 => {
      const {
        state
      } = t3;
      return state && values.filingsStates.includes(state);
    }) : data;
    $[1] = data;
    $[2] = values.filingsStates;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const filteredData = t2;
  let t3;
  if ($[4] !== data) {
    t3 = new Set(data.map(_temp).filter(_temp2));
    $[4] = data;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = [...t3];
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const stateFilterOptions = t4;
  if (!data.length) {
    let t5;
    if ($[8] !== t) {
      t5 = t(_temp3);
      $[8] = t;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    let t6;
    if ($[10] !== t5) {
      t6 = <Card.Empty>{t5}</Card.Empty>;
      $[10] = t5;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    return t6;
  }
  let t5;
  if ($[12] !== isMobile || $[13] !== t) {
    t5 = isMobile ? [{
      text: t(_temp4)
    }] : [{
      text: t(_temp5),
      width: "33%"
    }, {
      text: t(_temp6),
      width: "33%"
    }, {
      text: t(_temp7),
      width: "33%"
    }];
    $[12] = isMobile;
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const columns = t5;
  let t6;
  if ($[15] !== isMobile) {
    t6 = t7 => {
      const {
        item
      } = t7;
      return isMobile ? <MobileRow filing={item} /> : <Row filing={item} />;
    };
    $[15] = isMobile;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const renderTr = t6;
  let t7;
  if ($[17] !== queryParams.isReady || $[18] !== stateFilterOptions) {
    t7 = queryParams.isReady && <div className="px-4 py-2"><DrawerFilter states={stateFilterOptions} /></div>;
    $[17] = queryParams.isReady;
    $[18] = stateFilterOptions;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t) {
    t8 = t(_temp8);
    $[20] = t;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t) {
    t9 = t(_temp9);
    $[22] = t;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== onClick) {
    t10 = filing_0 => onClick(filing_0.id);
    $[24] = onClick;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== columns || $[27] !== filteredData || $[28] !== isMobile || $[29] !== renderTr || $[30] !== t10 || $[31] !== t8 || $[32] !== t9) {
    t11 = <FlushTable aria-label={t8} columns={columns} emptyStateText={t9} getKeyForRow={_temp10} hideThead={isMobile} items={filteredData} onRowClick={t10} renderTr={renderTr} />;
    $[26] = columns;
    $[27] = filteredData;
    $[28] = isMobile;
    $[29] = renderTr;
    $[30] = t10;
    $[31] = t8;
    $[32] = t9;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== t11 || $[35] !== t7) {
    t12 = <Card.Body className="pt-2 pb-3">{t7}{t11}</Card.Body>;
    $[34] = t11;
    $[35] = t7;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  return t12;
};
export default SOSFilings;
function _temp(t0) {
  const {
    state: state_0
  } = t0;
  return state_0;
}
function _temp2(state_1) {
  const isStateValid = Boolean(STATES.find(s => s.label === state_1));
  return isStateValid;
}
function _temp3($) {
  return $.table.emptyState;
}
function _temp4($_0) {
  return $_0.table.header.state;
}
function _temp5($_1) {
  return $_1.table.header.state;
}
function _temp6($_2) {
  return $_2.table.header.fileDate;
}
function _temp7($_3) {
  return $_3.table.header.status;
}
function _temp8($_4) {
  return $_4.table.ariaLabel;
}
function _temp9($_5) {
  return $_5.table.noMatches;
}
function _temp10(filing) {
  return filing.id;
}